import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentAssignmentInfo: {},
  topicAndSkillList: {},
  classDetails: [],
  selectedSubject: {},
  selectedTopicList: [],
  subjectList: [],
  selectedHomeworkFilters: {
    subject: {},
    level: {},
    topicAndSkills: {}
  },
  isCreateHomeworkModalOpen: false
};

export const homeworkSlice = createSlice({
  name: 'homework',
  initialState,
  reducers: {
    updateHomeworkInfo: (state, action: PayloadAction<any>) => {
      state.currentAssignmentInfo = action.payload;
    },
    updateTopicAndSkills: (state, action: PayloadAction<any>) => {
      state.topicAndSkillList = action.payload;
    },
    updateClassDetails: (state, action: PayloadAction<any>) => {
      state.classDetails = action.payload;
    },
    updateSelectedSubject: (state, action: PayloadAction<any>) => {
      state.selectedSubject = action.payload;
    },
    updateSelectedTopicList: (state, action: PayloadAction<any>) => {
      state.selectedTopicList = action.payload;
    },
    updateSubjectList: (state, action: PayloadAction<any>) => {
      state.subjectList = action.payload;
    },
    updateSelectedHomeworkFilters: (state, action: PayloadAction<any>) => {
      state.selectedHomeworkFilters = action.payload;
    },

    clearSelectedHomeworkFilters: (state) => {
      state.selectedHomeworkFilters = {
        subject: {},
        level: {},
        topicAndSkills: {}
      };
    },
    openCreateHomeworkModal: (state) => {
      state.isCreateHomeworkModalOpen = true;
    },

    closeCreateHomeworkModal: (state) => {
      state.isCreateHomeworkModalOpen = false;
    },
    resetHomeworkState: () => initialState
  }
});

export const {
  updateHomeworkInfo,
  resetHomeworkState,
  updateTopicAndSkills,
  updateClassDetails,
  updateSelectedSubject,
  updateSelectedTopicList,
  updateSubjectList,
  updateSelectedHomeworkFilters,
  clearSelectedHomeworkFilters,
  openCreateHomeworkModal,
  closeCreateHomeworkModal
} = homeworkSlice.actions;
export default homeworkSlice.reducer;
